import React from "react";


const ProductImages = () => {
   
    return (
        <div className="documents-container">
            
        </div>
    );
};


export default ProductImages;